module.exports = __webpack_public_path__ + "static/media/JS_Calculator.48d791b0.png";